import React, { Component } from 'react';
import ContractDBEForm from './ContractDBEForm'
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import { Button } from 'rsuite';

class ContractDBE extends Component {
    state = {
        proj_contract_dbe_id: null,
    }

    componentDidMount() {
        this.props.contractDBE.fetch();
    }
    render() {
        let smallModal = null;
        if (this.props.showSmallModal) {
            smallModal = (
                <SmallModal>
                    <ContractDBEForm
                        toggleSmallModalHandler={this.props.toggleSmallModalHandler}
                        currentContractDBE={this.state.proj_contract_dbe_id === null ? null : this.props.contractDBE.contractDBE.find(contractDBE => contractDBE.proj_contract_dbe_id === this.state.proj_contract_dbe_id)}
                        update={this.props.contractDBE.update}
                        add={this.props.contractDBE.add}
                        projectID={this.props.currentProjectID}
                        disabled={this.props.disabled}
                    />
                </SmallModal>
            )
        }
        return (
            <div>
                {this.props.disabled ? null : (
                    <div
                        style={{ textAlign: "right" }}
                    >
                        <Button
                            color={"blue"}
                            className={"my-2"}
                            onClick={() => { this.setState({ proj_contract_dbe_id: null }); this.props.toggleSmallModalHandler() }}>
                            Create New Contract DBE
                        </Button>
                    </div>
                )}
                {smallModal}



                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                Contract DBE Compliance
                            </th>
                            <th>
                                Contract DBE OJT Goal
                            </th>
                            <th>
                                Display order
                            </th>
                            <th>
                                Contract DBE Penalty
                            </th>
                            {this.props.disabled ? null : (
                                <th>
                                    Delete
                                </th>
                            )}

                        </tr>
                    </thead>
                    <tbody>
                        {this.props.contractDBE.contractDBE.map(item => (

                            <tr key={item.proj_contract_dbe_id} onClick={(e) => {


                                if (e.target.type !== 'button') {
                                    this.setState({
                                        proj_contract_dbe_id: item.proj_contract_dbe_id
                                    });
                                    this.props.toggleSmallModalHandler()
                                }
                            }
                            }>
                                <td>
                                    {item.contract_dbe_compliance}
                                </td>
                                <td>
                                    {item.contract_dbe_ojt_goal}
                                </td>
                                <td>
                                    {item.display_order}
                                </td>
                                <td>
                                    {item.contract_dbe_penalty}
                                </td>
                                {this.props.disabled ? null : (
                                    <td>
                                        <Button
                                            color="blue"
                                            type="button"
                                            onClick={() => {
                                                this.setState({
                                                    proj_contract_dbe_id:
                                                        item.proj_contract_dbe_id
                                                });
                                                this.props.toggleSmallModalHandler();
                                            }}
                                        >
                                            Edit
                    </Button>{" "}
                                        <Button color="red" type="button" onClick={() => this.props.contractDBE.delete(item.proj_contract_dbe_id, this.props.currentProjectID)}>Delete</Button>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        )
    }
}

export default ContractDBE;
